import React, {useState} from "react"
import ReactStars from "react-rating-stars-component"

export default function Stars({json, onChangeField})
{       
    const [ratingValue, setRatingValue] = useState(json.value || 0)    
    const ratingChanged = (newRating) => 
    {
        setRatingValue(newRating)
        if(onChangeField) onChangeField(json.key, newRating)
    }
    
    return (
        <>
            <div className={"json-input stars field_"+json.key}>
                <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />
                <ReactStars
                    count={5}
                    onChange={ratingChanged}
                    size={34}                    
                    activeColor="#f58220"
                    />
                <input className={"input_"+json.key} type="hidden" name={json.key} value={ratingValue} />
            </div>
        </>     
    ) 
}